export enum MemosTabViewState {
  DocumentsEmpty = 'documents-empty',
  Loading = 'loading',
  Table = 'table',
}

interface GetMemosTabViewStateParams {
  hasDocuments: boolean;
  isInitialLoading: boolean;
}

export function getMemosTabViewState({
  hasDocuments,
  isInitialLoading,
}: GetMemosTabViewStateParams): MemosTabViewState {
  if (isInitialLoading) {
    return MemosTabViewState.Loading;
  }

  if (!hasDocuments) {
    return MemosTabViewState.DocumentsEmpty;
  }

  return MemosTabViewState.Table;
}
